import { createFileRoute } from '@tanstack/react-router';
import { TeamTodayBoard } from '@/features/workforce/TeamTodayBoard';

export const Route = createFileRoute('/_app/workforce/today')({ component: TeamTodayPage });

function TeamTodayPage() {
  return <TeamTodayBoard standalone />;
}
